export const Button = (props) => {
    const { text, icon, toExecute } = props

    const handleClick = () => {
        toExecute()
    }

    return (
        <button
            className="c-sportRoutes-button"
            onClick={handleClick}
        >
            {icon && <i className={icon}></i>}
            {text}
        </button>
    );
}